import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import URL from 'url-parse';

import { CMSPage } from '@swf/cms';
import LoadingIndicator from '@swf/components/LoadingIndicator/LoadingIndicator';
import Translation from '@swf/components/Translation/Translation';
import type { ResolverTag } from '@swf/core/enums';
import useRequest from '@swf/core/hooks/useRequest';
import useResolver from '@swf/core/hooks/useResolver';
import type { Page, PageResponse } from '@swf/core/models/cms';
import type { Dispatch, RootState } from '@swf/core/store';
import { select } from '@swf/core/store';

import { TXTMOB_Something_went_wrongX_Please_t_ELL } from './ResolverCMSContent.messages.json';
import styles from './ResolverCMSContent.scss';

interface Props {
  tag?: ResolverTag;
  pathname?: string;
}

const ResolverCMSContent: React.FC<Props> = ({ tag, pathname }) => {
  const url = useResolver(tag);
  const request = useRequest();
  const strippedPathname = useSelector((rootState: RootState) =>
    select.location.stripLocale(rootState, new URL(url).pathname)
  );
  const [cmsPage, setCmsPage] = useState<Page>();
  const [error, setError] = useState(false);
  const {
    cms: { update }
  } = useDispatch<Dispatch>();

  useEffect(() => {
    if (!url && !pathname) return;
    const path = pathname || strippedPathname;
    request<PageResponse>({ service: 'cms.page', body: { path } }).subscribe(({ body }) => {
      const { content, page } = body;
      update({ content });
      setCmsPage(page);
    }, setError);
    // TODO: Fix stability of request
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, pathname, update, strippedPathname]);

  return (
    <LoadingIndicator loading={!cmsPage} className={styles.loading}>
      {error || !cmsPage ? (
        <div className={styles.error}>
          <Translation tagName="p" {...TXTMOB_Something_went_wrongX_Please_t_ELL} />
        </div>
      ) : (
        <CMSPage {...cmsPage} />
      )}
    </LoadingIndicator>
  );
};

export default ResolverCMSContent;
